export const COPY_WORKFLOW_WEBHOOK_REQUEST = `WORKFLOW_WEBHOOK_INDEX_COPY_WORKFLOW_WEBHOOK_REQUEST`;
export const DELETE_WORKFLOW_WEBHOOKS_REQUEST = `WORKFLOW_WEBHOOK_INDEX_DELETE_WORKFLOW_WEBHOOKS_REQUEST`;
